import React from 'react';
import styled, { css } from 'styled-components';
import breakpoints from '../../../vars/breakpoints';
import gutters from '../../../vars/gutters';
import colors from '../../../vars/colors';

export const StatCircleElement = styled.div`
        background: ${ props => props.circleColor === 'black' ? colors['black'] : colors['white']};
        height: 140px;
        width: 140px;
        box-sizing: border-box;
        border-style: solid;
        border-width: 4px;
        border-radius: 75px;
        border-color: ${ props => props.circleColor === 'black' ? colors['black'] : (props.circleColor === 'red' ? colors['lipstick'] : colors['peacock-blue']) };
        display: flex;
        align-items: center;
        justify-content: space-around;
        font-size: 80px;
        color: ${ props => props.circleColor === 'black' ? colors['white'] : (props.circleColor === 'red' ? colors['lipstick'] : colors['peacock-blue']) };
        font-family: 'OneDotCd', sans-serif;
        font-weight: bold;
        position: relative;
        .circleLabel {
            position: absolute;
            top: -20px;
            bottom: -20px;
            left: -20px;
            right: -20px;
        }
        @media (max-width: ${breakpoints['bp-mobile']}) { 
            height: 85px;
            width: 85px;
            font-size: 46px;
        }
`;



// WEBPACK FOOTER //
// ./src/components/modules/StatCircle/styled-components.js